import localStorage from '@/utils/localStorage';
import API from "@/api";

const thirdLoginPtids = ['maycur'];
let ptid = localStorage.get('ptid');
let entryUrlParsed = localStorage.get('entryUrlParsed') || '';

function checkNeedThirdLogin() {
  return thirdLoginPtids.indexOf(ptid) > -1;
}

function thirdLogin() {
  return Promise.resolve().then(() => {
    if (ptid === "maycur") {
      if (entryUrlParsed && entryUrlParsed.phone) {
        return API.login["331623"]({
          passengerMobile: entryUrlParsed.phone,
          maycurSignValue: entryUrlParsed.mid || '',
          timestamp: entryUrlParsed.timestamp || ''
        }).then(r => {
          if (r && r.authcode) {
            localStorage.set('authcode', r.authcode);
            return;
          } else {
            throw {
              type: "PHONECODE_LOGIN"
            };
          }
        })
      } else {
        throw {
          type: "PHONECODE_LOGIN"
        };
      }
    } else {
      throw {
        type: "PHONECODE_LOGIN"
      };
    }
  });
}

export default {
  checkNeedThirdLogin,
  thirdLogin
}



// WEBPACK FOOTER //
// ./src/auth/thirdLogin.js